import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const NumberMatcher: FieldMatcher = {
  name: 'numberMatch',
  displayName: 'Number Comparison',
  hasEditor: true,
  options: {
    chipFormatter: ((value: { operator: string; value: number }) =>
      `${value.operator} ${value.value}`) as unknown as (
      arg0: string
    ) => string,
  },
  validators: [
    {
      errorKey: 'notANumber',
      errorMessage: 'Value must be a number',
      validator: (control) => {
        const value = control.value?.value;
        return Number.isNaN(value) ? { notANumber: true } : null;
      },
    },
  ],
};